import FormConfiguration, {
    BackCreateWidgetHome,
    BoutonSupprimerWidget,
    TitreConfigurerPhidget,
    WidgetTitre
} from "./FormConfiguration";
import React, {useEffect, useState} from "react";
import styles from "./CreateForm.module.scss";
import {Button, FormCheck, FormControl, FormSelect} from "react-bootstrap";
import {useStores} from "../../stores/Context";
import {v4 as uuidv4} from "uuid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import {useParams} from "react-router-dom";
import PaletteCouleurs from "../PaletteCouleurs";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";
import BtnAction from "../../boiteAOutils/BtnAction";
import {createAxiosEntrepriseInstance} from "../../axiosEntreprise";
import BtnSvg from "../../boiteAOutils/BtnSvg";

const CreateTableauBlanc = () => {
    const {widgetStore, uiStore, createWidgetStore} = useStores();
    const [typeForm, setTypeForm] = useState('');
    const [nameError, setNameError] = useState(false);
    const [widgetName, setWidgetName] = useState('');

    useEffect(() => {
        if (createWidgetStore.idWidgetModification === '') {
            setTypeForm("creation");
        } else {
            setTypeForm("modification");
            widgetStore.getWidgetDataConfigById(createWidgetStore.idWidgetModification)
                .then(value => {
                    setWidgetName(value.nomWidget)
                })
                .catch(error => {
                    uiStore.closePanel();
                    console.log("error", error)
                });
        }
    }, [createWidgetStore.idWidgetModification]);
    function getData() {
        if (widgetName.length > 0) {
            console.log("coucou", typeForm)
            if (typeForm === "creation") {
                console.log('coucou');
                widgetStore.addWidgetAvailable({
                    idWidget: uuidv4(),
                    typeWidget: 'WidgetTableauBlanc',
                    nomWidget: widgetName,
                    config: {
                        tb_nom: widgetName
                    }
                });
            } else if (typeForm === "modification") {
                widgetStore.updateWidgetAvailable({
                    idWidget: createWidgetStore.idWidgetModification,
                    typeWidget: 'WidgetTableauBlanc',
                    nomWidget: widgetName,
                    config: {
                        tb_nom: widgetName
                    }
                });
            }
            uiStore.backNivOAfterAddPhidget();
        } else {
            if (widgetName.length === 0) {
                setNameError(true);
            } else {
                setNameError(false);
            }
        }
    }

    return (
        <>

            <div>
                <TitreConfigurerPhidget/>
                <WidgetTitre titre={"Tableau blanc"}/>
            </div>

            <div className={styles.listeChampsFormulaire}>
                <div className={styles.form_add_widget}>
                    <label>Nom du phidget :</label>
                    <FormControl
                        className={`${nameError && 'border border-danger'}`}
                        onChange={(e) => setWidgetName(e.target.value)}
                        value={widgetName}
                    />
                    {nameError && <small className="text-danger">Nom obligatoire</small>}
                </div>
            </div>

            <div className={styles.WidgetButtonContent}>
                {(createWidgetStore.idWidgetModification === '') ? <FormConfiguration/> :
                    <BoutonSupprimerWidget
                        idWidget={createWidgetStore.idWidgetModification}
                        widgetName={widgetName}
                        typeWidget={"WidgetURL"}
                    />}
                <BtnPrimary
                    onClick={getData}>{(createWidgetStore.idWidgetModification === '') ? "Ajouter à mes phidgets" : "Modifier mon phidget"}</BtnPrimary>
            </div>
        </>
    );
};

export default CreateTableauBlanc;
